export enum ContentType {
  Stories = 'Stories',
  SexSounds = 'SexSounds',
  Soul = 'Soul',
  SurpriseMe = 'SurpriseMe',
}

export enum Scenarios {
  FemaleMale = 'FemaleMale',
  FemaleFemale = 'FemaleFemale',
  MaleMale = 'MaleMale',
  NonBinary = 'NonBinary',
  SurpriseMe = 'SurpriseMe',
}
